import CompletionRow from './CompletionRow';
import styles from './CompletionBreakdown.module.scss';

interface Props {
  colA: string;
  colB: string;
  colC: string;
  data: {
    id: string;
    displayName: string;
    totalModules: number;
    completeModules: number;
  }[];
  barColor: string;
  isShouldAnimate: boolean;
}

const CompletionBreakdown = ({ colA, colB, colC, data, barColor, isShouldAnimate }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.columnTitles}>
        <div className={styles.col1}>
          <h4>{colA}</h4>
        </div>
        <div className={styles.col2}>
          <h4>{colB}</h4>
        </div>
        <div className={styles.col3}>
          <h4>{colC}</h4>
        </div>
      </div>
      {data.map((unit) => {
        const { displayName, id, totalModules, completeModules } = unit;
        return (
          <CompletionRow
            key={`${id} unit completion`}
            title={displayName}
            totalModules={totalModules}
            completeModules={completeModules}
            barColor={barColor}
            isShouldAnimate={isShouldAnimate}
            id={id}
          />
        );
      })}
    </div>
  );
};

export default CompletionBreakdown;
